module.exports = __webpack_public_path__ + "static/media/view-demo-3.f7ffd722.png";